<template>
	<div class="intersection-child" ref="container">
		<slot />
	</div>
</template>

<script>
export default {
	name: 'IntersectionChild',
	inject: {
		registerIntersectionChild: {
			default: () => null,
		},
	},
	emits: ['enter', 'leave'],
	mounted() {
		this.$nextTick(() => {
			if (!this.registerIntersectionChild) return false
			this.registerIntersectionChild(this.$refs.container, (entry) => {
				this.$emit(entry.isIntersecting ? 'enter' : 'leave', entry)
			})
		})
	},
}
</script>
